import type { ReactNode } from 'react';

export const ENTITY_ID_RE = /\b(?:fp_b?id|pb|inv|ob|av|ag)_[A-Za-z0-9_]{10,}\b/g;
export const ENTITY_ID_EXACT_RE = /^(?:fp_b?id|pb|inv|ob|av|ag)_[A-Za-z0-9_]{10,}$/;
export const FP_ENTITY_SCHEME = 'fpentity:';

// Skip regions where entity IDs must not be rewritten:
//  - fenced code blocks (``` or ~~~)
//  - inline code spans (one or more backticks)
//  - markdown links and images, e.g. [label](url) or ![alt](url)
//  - bare URLs
const SKIP_REGION_RE =
  /(?:^|\n)([ \t]{0,3})(`{3,}|~{3,})[^\n]*\n[\s\S]*?\n\1\2[ \t]*(?=\n|$)|(`+)(?:(?!\3)[\s\S])+?\3|!?\[[^\]\n]*\]\([^)\n]*\)|https?:\/\/\S+/g;

const linkify = (s: string) => s.replace(ENTITY_ID_RE, t => `[${t}](${FP_ENTITY_SCHEME}${t})`);

export const linkifyFpIds = (md: string) => {
  let out = '';
  let last = 0;
  for (const m of md.matchAll(SKIP_REGION_RE)) {
    out += linkify(md.slice(last, m.index));
    out += m[0];
    last = m.index + m[0].length;
  }
  out += linkify(md.slice(last));
  return out;
};

export const childrenToText = (children: ReactNode): string => {
  if (typeof children === 'string') return children;
  if (Array.isArray(children)) return children.join('');
  return '';
};
